// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"bq-z","imageAndVideoCount":"cq-z","imageAndVideoContainer":"dq-z","viewAllReviews":"eq-z"};